export enum DataBuilderTypes {
	dataframe = 'dataframe',
	chart = 'chart',
	report = 'report',
	table = 'table',
	presentation = 'presentation',
	dashboard = 'dashboard',
}
